import { jsx, jsxs } from "react/jsx-runtime";
import { c as classNames } from "../../index-CweZ_OcN.js";
import "../Icon/index.es.js";
import { IconX } from "../icons/IconX/index.es.js";
import './styles.css';const Drawer = ({
  renderHeader,
  renderContent,
  isOpen = false,
  handleOpen
}) => {
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: classNames("au-drawer", {
        "au-drawer--is-open": isOpen
      }),
      children: /* @__PURE__ */ jsxs("div", { className: "au-drawer__container", children: [
        /* @__PURE__ */ jsxs("div", { className: "au-drawer__header", children: [
          renderHeader,
          /* @__PURE__ */ jsx("div", { className: "au-drawer__header-close", onClick: handleOpen, children: /* @__PURE__ */ jsx(IconX, {}) })
        ] }),
        /* @__PURE__ */ jsx("div", { className: "au-drawer__content", children: renderContent })
      ] })
    }
  );
};
export {
  Drawer
};
//# sourceMappingURL=index.es.js.map
